import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "../config/firebase";
import { consumeApi } from "./tools";

export const requestForToken = async (userId: string) => {
    if (!messaging) return;

    try {
        const currentToken = await getToken(messaging, {
            vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY, // Needs to be added to .env
        });

        if (currentToken) {
            console.log("Firebase push token generated:", currentToken);
            // Retrieve the current user from backend to check if the token is already present
            // Alternatively wait, we can just fetch user data entirely, or send the token
            // The backend expects `push_token` to be a JSON string array of tokens
            // But we just need to append this new token or keep it if it exists.
            // Easiest is to send an initialization endpoint but since it's `update_user`
            // We will perform a fetch user, check token, and if missing, append and push.
            const response = await consumeApi("users/get_user_by_id", "POST", {
                user_id: userId,
            });

            if (response.status === "success" && response.user_data) {
                let pushTokens: string[] = [];
                try {
                    if (response.user_data.push_token) {
                        pushTokens = JSON.parse(response.user_data.push_token);
                        if (!Array.isArray(pushTokens)) {
                            pushTokens = [response.user_data.push_token];
                        }
                    }
                } catch (e) {
                    pushTokens = [response.user_data.push_token];
                }

                if (!pushTokens.includes(currentToken)) {
                    pushTokens.push(currentToken);
                    await consumeApi("users/update_user", "POST", {
                        user_id: userId,
                        fields_to_update: { push_token: JSON.stringify(pushTokens) },
                    });
                    console.log("Token sent to backend database.");
                } else {
                    console.log("Token already exists in backend.");
                }
            }
        } else {
            console.log(
                "No registration token available. Request permission to generate one."
            );
        }
    } catch (err) {
        console.log("An error occurred while retrieving token. ", err);
    }
};

export const onMessageListener = () =>
    new Promise((resolve) => {
        if (!messaging) return;
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });
